let domain = ''
let saasDomain = ''
let socket = 'wss://wsdev.docbook.com.cn:8443'
let env = ''
let pcEnv = ''
let javaDoMain = ''
let authDomain = ''
let authEnv = ''
let imageHost = 'https://oss.healthyltx.org.cn/'

if (/release-m/.test(window.location.href)) {
    domain = 'https://mapirelease.docbook.com.cn'
    saasDomain = 'https://dev-manapi.docbook.cn'
    javaDoMain = 'https://workstationtest3.docbook.com.cn'
    authDomain = 'https://cotdftest3.docbook.com.cn/#/'
    authEnv = 'bugfix'
    env = 'release'
    pcEnv = 'release'
    imageHost = 'https://osstest.docbook.com.cn/pics/'
} else if (/localhost/.test(window.location.href)) {
    domain = 'https://workstation.healthyltx.org.cn'
    saasDomain = 'https://manapi.docbook.cn'
    javaDoMain = 'https://workstation.healthyltx.org.cn'
    authDomain = 'https://cotdftest3.docbook.com.cn/#/'
    authEnv = 'bugfix'
    env = 'release'
    pcEnv = 'release'
    imageHost = 'https://osstest.docbook.com.cn/pics/'
} else if (/192.168/.test(window.location.href)) {
    domain = 'https://mapirelease.docbook.com.cn'
    saasDomain = 'https://dev-manapi.docbook.cn'
    javaDoMain = 'https://workstationtest3.docbook.com.cn'
    authDomain = 'https://cotdftest3.docbook.com.cn/#/'
    authEnv = 'bugfix'
    env = 'release'
    pcEnv = 'release'
    imageHost = 'https://osstest.docbook.com.cn/pics/'
} else {
    domain = 'https://workstation.healthyltx.org.cn'
    saasDomain = 'https://manapi.docbook.cn'
    socket = 'wss://ws.healthyltx.org.cn:8443'
    javaDoMain = 'https://workstation.healthyltx.org.cn'
    authDomain = 'https://cotdf.healthyltx.org.cn/#/'
    authEnv = 'production'
}


export default {
    domain,
    saasDomain,
    javaDoMain,
    socket,
    env,
    pcEnv,
    authDomain,
    authEnv,
    imageHost
}
